var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardTodoMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7H4.00667M7 7H7.00667M10 7H10.0067M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 7.7981 1.15582 8.5598 1.43871 9.25634C1.49285 9.38965 1.51992 9.45631 1.532 9.51019C1.54381 9.56289 1.54813 9.6019 1.54814 9.65591C1.54814 9.71113 1.53812 9.77128 1.51807 9.89157L1.12275 12.2635C1.08135 12.5119 1.06065 12.6361 1.09917 12.7259C1.13289 12.8045 1.19552 12.8671 1.27412 12.9008C1.36393 12.9393 1.48812 12.9186 1.73651 12.8772L4.10843 12.4819C4.22872 12.4619 4.28887 12.4519 4.34409 12.4519C4.3981 12.4519 4.43711 12.4562 4.48981 12.468C4.54369 12.4801 4.61035 12.5072 4.74366 12.5613C5.4402 12.8442 6.2019 13 7 13ZM4.33333 7C4.33333 7.1841 4.1841 7.33333 4 7.33333C3.81591 7.33333 3.66667 7.1841 3.66667 7C3.66667 6.81591 3.81591 6.66667 4 6.66667C4.1841 6.66667 4.33333 6.81591 4.33333 7ZM7.33333 7C7.33333 7.1841 7.1841 7.33333 7 7.33333C6.81591 7.33333 6.66667 7.1841 6.66667 7C6.66667 6.81591 6.81591 6.66667 7 6.66667C7.1841 6.66667 7.33333 6.81591 7.33333 7ZM10.3333 7C10.3333 7.1841 10.1841 7.33333 10 7.33333C9.81591 7.33333 9.66667 7.1841 9.66667 7C9.66667 6.81591 9.81591 6.66667 10 6.66667C10.1841 6.66667 10.3333 6.81591 10.3333 7Z",
    stroke: "#6987B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTodoMessage);
export default __webpack_public_path__ + "static/media/DashboardTodoMessage.ced7eec3d4892e09b78bb75b59b74b99.svg";
export { ForwardRef as ReactComponent };